.app {
  height: 100dvh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background:
    radial-gradient(ellipse at 0 0, var(--blue-glow), transparent 67%),
    radial-gradient(ellipse at 100% 15%, var(--purple-glow), transparent 65%),
    var(--bg);
}
.navigation,
.calendar,
.tasks,
.loginCard {
  background: var(--panel);
  border-radius: 18px;
  box-shadow: var(--shadow);
  backdrop-filter: blur(10px);
}
.navigation {
  flex-shrink: 0;
  min-width: 0;
}
.mast {
  height: 57px;
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 0 24px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
}
.brandIcon {
  background: var(--accent);
  color: var(--on-accent);
  width: 32px;
  height: 32px;
  display: inline-grid;
  place-items: center;
  border-radius: 9px;
  box-shadow: 0 2px 5px #5575c426;
}
.groups {
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}
.navGroup {
  display: flex;
  align-items: center;
  white-space: nowrap;
  position: relative;
  gap: 0;
}
.groupShell {
  position: relative;
}
.navGroup .dragBody {
  gap: 0;
  cursor: grab;
}
.navGroup .dragBody > span {
  padding: 12px 2px;
  color: var(--muted);
}
.navGroup.active .dragBody > span {
  color: var(--accent);
  border-bottom: 2px solid var(--accent);
}
.grip {
  opacity: 0.28;
}
.navGroup:hover .grip {
  opacity: 1;
}
.groupInsertion {
  position: absolute;
  z-index: 6;
  top: 7px;
  bottom: 7px;
  width: 2px;
  border-radius: 2px;
  background: var(--accent);
  pointer-events: none;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent) 12%, transparent);
}
.groupInsertionBefore {
  left: -9px;
}
.groupInsertionAfter {
  right: -9px;
}
.account {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}
.account button {
  color: var(--muted);
}
.avatar {
  display: grid;
  place-items: center;
  background: var(--soft);
  color: var(--accent);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 12px;
}
.saveState {
  font-size: 11px;
  color: var(--muted);
}
.sites {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 2px 22px 13px;
  min-height: 49px;
  overflow-x: auto;
  scrollbar-width: thin;
  white-space: nowrap;
}
.siteShell {
  position: relative;
  flex: 0 0 auto;
  padding: 0 12px;
}
.site {
  display: flex;
  align-items: center;
}
.site .dragBody {
  gap: 0;
  cursor: grab;
}
.site .dragBody > a {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 33px;
  font-size: 13px;
  line-height: 1;
  user-select: none;
}
.site .dragBody > a:hover {
  color: var(--accent);
}
.site img,
.siteIcon {
  display: block;
  flex: 0 0 23px;
  width: 23px;
  height: 23px;
  border-radius: 5px;
  object-fit: contain;
}
.siteIcon {
  display: grid;
  place-items: center;
  background: var(--soft);
  color: var(--muted);
}
.siteTitle {
  display: flex;
  align-items: center;
  height: 23px;
  line-height: 23px;
}
.siteInsertion {
  position: absolute;
  z-index: 6;
  top: -2px;
  bottom: -2px;
  width: 3px;
  border-radius: 3px;
  background: var(--accent);
  pointer-events: none;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--accent) 12%, transparent);
}
.siteInsertionBefore {
  left: -1px;
}
.siteInsertionAfter {
  right: -1px;
}
.addSite {
  margin-left: auto;
  color: var(--muted);
  font-size: 12px;
  flex-shrink: 0;
}
.main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 14px var(--sidebar);
  min-height: 0;
  flex: 1;
}
.split {
  cursor: col-resize;
  touch-action: none;
  position: relative;
}
.split:hover:after {
  content: "";
  position: absolute;
  left: 5px;
  top: 40%;
  bottom: 40%;
  width: 3px;
  background: var(--accent);
  border-radius: 3px;
}
.calendar,
.tasks {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panelHead {
  height: 69px;
  flex: 0 0 69px;
  padding: 0 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.panelHead h1 small {
  margin-left: 8px;
  font-size: 12px;
}
.inline {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.inline > a,
.inline > input {
  flex: 1;
  min-width: 0;
}
.inline > a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.outline {
  border: 1px solid var(--line);
  border-radius: 7px;
  padding: 5px 12px;
  font-size: 12px;
  white-space: nowrap;
}
.primary {
  background: var(--accent);
  color: var(--on-accent);
  padding: 9px 17px;
  border-radius: 8px;
}
.primary:hover {
  filter: brightness(0.97);
  background: var(--accent);
}
.weekdays {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  height: 29px;
  flex: 0 0 29px;
  font-size: 11px;
  color: var(--muted);
  border-bottom: 1px solid var(--line);
}
.weekdays span {
  padding-left: 12px;
}
.weeks {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: none;
  overscroll-behavior: contain;
  --week-height: 116px;
}
.weeks::-webkit-scrollbar {
  display: none;
}
.week {
  height: var(--week-height);
  position: relative;
  border-bottom: 1px solid var(--line);
}
.dateGrid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  height: 100%;
}
.day {
  border-right: 1px solid var(--line);
  padding: 8px 7px 0;
  min-width: 0;
}
.day:last-child {
  border-right: 0;
}
.today {
  background: color-mix(in srgb, var(--accent) 5%, transparent);
}
.dateLabel {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  white-space: nowrap;
}
.dateLabel > span {
  height: 23px;
  min-width: 23px;
  display: inline-grid;
  place-items: center;
}
.dateLabel small {
  margin-left: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.todayNumber {
  background: var(--accent);
  color: var(--on-accent);
  border-radius: 50%;
}
.rest,
.work {
  font-size: 11px;
  font-style: normal;
  color: var(--danger);
}
.work {
  color: #af9156;
}
.festival {
  color: var(--danger);
}
.lanes {
  position: absolute;
  inset: 35px 0 auto;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-template-rows: 18px 24px 24px;
  row-gap: 4px;
  pointer-events: none;
}
.bar {
  --item-color: #5c82d9;
  position: relative;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 4px;
  padding: 0 9px;
  background: color-mix(in srgb, var(--item-color) 12%, var(--solid));
  color: color-mix(in srgb, var(--item-color) 35%, var(--text));
  border-radius: 5px;
  border-left: 2px solid var(--item-color);
  pointer-events: auto;
  font-size: 11px;
  touch-action: pan-y;
  cursor: default;
}
.calendarMenu {
  position: fixed;
  z-index: 1000;
  min-width: 170px;
  max-width: min(280px, calc(100vw - 16px));
  padding: 6px;
  background: var(--solid);
  color: var(--text);
  border: 1px solid var(--line);
  border-radius: 10px;
  box-shadow: 0 8px 32px #101b3826;
}
.calendarSortable {
  cursor: ns-resize;
}
.calendarDragging {
  z-index: 5;
  opacity: 0.72;
  cursor: ns-resize;
  box-shadow: 0 3px 12px #101b3826;
}
.calendarDropBefore:before,
.calendarDropAfter:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--accent);
  pointer-events: none;
  z-index: 6;
}
.calendarDropBefore:before {
  top: -3px;
}
.calendarDropAfter:before {
  bottom: -3px;
}
.taskRowShell {
  position: relative;
}
.taskDropZone {
  position: absolute;
  left: 0;
  right: 0;
  height: 50%;
  z-index: 5;
}
.taskDropBefore {
  top: 0;
}
.taskDropAfter {
  bottom: 0;
}
.taskDropZone.dropActive {
  background: transparent;
  outline: none;
}
.taskDropZone.dropActive span {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--accent);
  border-radius: 2px;
}
.taskDropBefore span {
  top: 0;
}
.taskDropAfter span {
  bottom: 0;
}
.calendarMenu small {
  display: block;
  padding: 6px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--muted);
}
.calendarMenu button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
}
.calendarMenu button:disabled {
  opacity: 0.4;
  cursor: default;
}
.barTitle {
  padding: 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
  text-align: left;
  color: inherit;
  font-size: 12px;
}
.barTitle:hover {
  background: transparent;
}
.bar .grip {
  padding: 0;
  position: absolute;
  left: 0;
  width: 6px;
  overflow: hidden;
  opacity: 0;
}
.bar:hover .grip {
  opacity: 0.6;
  width: 10px;
  left: 2px;
  background: var(--solid);
  z-index: 2;
}
.bar .check {
  height: 12px;
  width: 12px;
  flex-basis: 12px;
}
.eventBar {
  border-left: 0;
  background: color-mix(in srgb, var(--item-color) 6%, var(--solid));
  font-size: 11px;
}
.eventBar .barTitle {
  font-size: 11px;
}
.agenda .bar {
  touch-action: pan-y;
}
.agenda .dragBody {
  cursor: default;
}
.continuation {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-color: transparent;
}
.continues {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.done {
  opacity: 0.72;
}
.overdue:after {
  content: "";
  position: absolute;
  right: 2px;
  top: 2px;
  width: 3px;
  height: 3px;
  background: var(--danger);
  border-radius: 50%;
}
.resizeHandle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 7px;
  cursor: ew-resize;
  z-index: 3;
  touch-action: none;
}
.resizeStart {
  left: -2px;
}
.resizeEnd {
  right: -2px;
}
.resizeHandle:hover {
  background: var(--item-color);
  opacity: 0.35;
}
.bar.selectedItem .resizeHandle {
  background: color-mix(in srgb, var(--item-color) 45%, transparent);
  border-radius: 3px;
}
.overflowGrid {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 1px;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  pointer-events: none;
}
.overflowGrid > div {
  min-width: 0;
  overflow: hidden;
}
.overflowGrid button {
  font-size: 11px;
  padding: 0 7px;
  color: var(--muted);
  white-space: nowrap;
  pointer-events: auto;
}
.calendarFoot {
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 14px;
  font-size: 11px;
  color: var(--muted);
  border-top: 1px solid var(--line);
}
.filters {
  display: flex;
  gap: 16px;
  padding: 0 21px;
  border-bottom: 1px solid var(--line);
  height: 30px;
  flex-shrink: 0;
}
.filters button {
  font-size: 12px;
  white-space: nowrap;
  color: var(--muted);
  padding: 0 0 9px;
  border-radius: 0;
}
.filters button.active {
  border-bottom: 2px solid var(--accent);
  color: var(--accent);
}
.taskScroll {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: var(--line) transparent;
  scrollbar-gutter: stable;
}
.taskBoard {
  display: grid;
  align-items: start;
  gap: 12px;
  padding: 14px;
  min-height: 100%;
}
.taskColumn {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  min-height: 100%;
}
.cardShell {
  display: flex;
  position: relative;
  min-width: 0;
  min-height: 160px;
  flex-shrink: 0;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: color-mix(in srgb, var(--soft) 26%, var(--panel));
  box-shadow: 0 3px 12px color-mix(in srgb, var(--text) 4%, transparent);
}
.cardShell:hover {
  border-color: color-mix(in srgb, var(--accent) 22%, var(--line));
}
.cardClosed {
  min-height: 0;
}
.cardResizing {
  border-color: var(--accent);
  user-select: none;
}
.taskGroup {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  border-radius: inherit;
  overflow: hidden;
}
.cardHeader {
  padding: 12px 10px 2px;
  flex-shrink: 0;
}
.cardBody {
  padding: 0 10px 10px;
  overflow-y: auto;
  min-height: 0;
  flex: 1 1 auto;
  scrollbar-width: thin;
  scrollbar-color: var(--line) transparent;
  overscroll-behavior: contain;
}
.cardClosed .cardBody:empty {
  display: none;
}
.cardResize {
  flex: 0 0 16px;
  padding: 0;
  width: 100%;
  cursor: ns-resize;
  touch-action: none;
  border-radius: 0;
  color: var(--muted);
}
.cardResize span {
  width: 28px;
  height: 3px;
  border-radius: 3px;
  background: currentColor;
  opacity: 0.3;
}
.cardResize:hover,
.cardResize:focus-visible {
  color: var(--accent);
}
.cardDropZone {
  position: absolute;
  left: -2px;
  right: -2px;
  height: 50%;
  z-index: 5;
  border-radius: 10px;
}
.cardDropZone span {
  display: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 3px 8px;
  background: var(--accent);
  color: var(--on-accent);
  border-radius: 5px;
  font-size: 11px;
  white-space: nowrap;
}
.cardDropBefore {
  top: -2px;
}
.cardDropAfter {
  bottom: -2px;
}
.cardDropBefore span {
  top: -8px;
}
.cardDropAfter span {
  bottom: -8px;
}
.cardDropZone.dropActive span {
  display: block;
}
.columnEnd {
  flex: 1 0 100px;
  min-height: 100px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: var(--muted);
  font-size: 12px;
}
.boardDragging .columnEnd {
  border: 1px dashed color-mix(in srgb, var(--accent) 40%, var(--line));
  background: var(--soft);
}
.parentRow {
  display: flex;
  align-items: center;
  gap: 3px;
}
.parentRow > button:not(.parentTitle):not(.check) {
  padding: 3px;
  flex-shrink: 0;
}
.parentRow > input {
  min-width: 0;
  padding: 3px;
}
.parentRow .grip {
  opacity: 0.5;
}
.parentRow:hover .grip {
  opacity: 1;
}
.parentTitle {
  min-width: 0;
  flex: 1;
  text-align: left;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  padding: 0;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--item-color);
  flex: 0 0 6px;
}
.progress {
  font-size: 11px;
  color: var(--muted);
  white-space: nowrap;
}
.groupMeta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 5px 0 10px 22px;
  color: var(--muted);
  font-size: 11px;
  flex-wrap: wrap;
}
.progressTrack {
  width: 35px;
  height: 3px;
  border-radius: 3px;
  background: var(--line);
  overflow: hidden;
}
.progressTrack > i {
  display: block;
  height: 100%;
  background: var(--item-color);
}
.taskRow {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  border-radius: 7px;
  padding: 8px 8px 8px 10px;
}
.taskRow:hover {
  background: var(--soft);
}
.taskRow .grip {
  padding: 0;
  width: 11px;
  flex: 0 0 11px;
  opacity: 0;
}
.taskRow:hover .grip {
  opacity: 0.6;
}
.taskBody {
  text-align: left;
  min-width: 0;
  flex: 1;
  display: block;
  padding: 0;
}
.taskBody:hover {
  background: none;
}
.taskBody > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.titleSlot {
  display: block;
  min-width: 0;
  overflow: hidden;
}
.inlineTitle {
  display: block;
  min-width: 0;
  width: auto;
  max-width: 100%;
  field-sizing: content;
  margin: 0;
  padding: 0;
  color: inherit;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 13px;
  text-overflow: ellipsis;
  cursor: text;
  outline: none;
}
.inlineTitle[data-editing="true"] {
  width: 100%;
  background: var(--solid);
  border-color: var(--accent);
  text-overflow: clip;
  user-select: text;
}
.inlineTitle:focus-visible {
  outline: 1px solid var(--accent);
}
.bar .inlineTitle {
  font-size: 12px;
}
.selectable {
  cursor: default;
}
.selectable[data-selected="true"] {
  cursor: grab;
}
.selectable[data-drag-state="dragging"] {
  cursor: grabbing;
}
.taskRow.selectedItem,
.bar.selectedItem {
  outline: 2px solid color-mix(in srgb, var(--accent) 65%, transparent);
  outline-offset: -1px;
  background-color: color-mix(in srgb, var(--accent) 10%, var(--solid));
}
.cardResize {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 16px;
  border-radius: 0 0 11px 11px;
}
.cardBody {
  padding-bottom: 20px;
}
.taskBody small {
  display: block;
  font-size: 11px;
  margin-top: 3px;
}
.check {
  display: inline-grid;
  place-items: center;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  padding: 0;
  border: 1px solid currentColor;
  border-radius: 3px;
  color: var(--muted);
}
.checked {
  color: var(--item-color, var(--accent));
}
.link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  padding: 1px;
}
.link:hover {
  color: var(--accent);
}
.addChild {
  font-size: 12px;
  color: var(--muted);
  margin: 6px 0 0 20px;
  padding: 5px 0;
}
.quick {
  display: flex;
  gap: 2px;
  margin: 6px 0 0 19px;
}
.quick input {
  font-size: 12px;
  padding: 6px;
}
.dropActive {
  background: color-mix(in srgb, var(--accent) 10%, transparent) !important;
  box-shadow: inset 0 0 0 1px var(--accent);
}
.dragging {
  opacity: 0.35;
}
.dragBody {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  flex: 1;
  cursor: grab;
}
.grip {
  cursor: grab;
  color: var(--muted);
  touch-action: none;
}
.dragPreview,
.dragStatus {
  padding: 8px 12px;
  background: var(--solid);
  box-shadow: var(--shadow);
  border: 1px solid var(--line);
  border-radius: 8px;
  font-size: 12px;
}
.dragStatus {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  pointer-events: none;
}
.mobileTabs {
  display: none;
}
.taskSearch {
  padding: 0 18px 10px;
}
.taskSearch input {
  font-size: 12px;
}
.trashRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--line);
}
.trashRow small {
  display: block;
}
.overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: #17243d35;
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 8vh 18px 30px;
  overflow-y: auto;
}
.modal {
  background: var(--solid);
  border: 1px solid var(--line);
  border-radius: 18px;
  box-shadow: 0 20px 70px #162b5030;
  padding: 23px;
  width: 440px;
  max-width: 100%;
  max-height: 84dvh;
  overflow: auto;
}
.modal.wide {
  width: 700px;
}
.modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.modal footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}
.modal form > input {
  margin: 5px 0;
}
.modal .filters {
  padding: 0;
  margin-bottom: 20px;
}
.two,
.three {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.hint {
  color: var(--muted);
  font-size: 12px;
  margin: 10px 0;
  line-height: 1.6;
}
.error {
  color: var(--danger) !important;
}
.danger {
  color: var(--danger);
  font-size: 12px;
}
.subtle {
  font-size: 12px;
  color: var(--muted);
}
.colors {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 7px;
}
.colors > button {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 0;
}
.colors > button[aria-pressed="true"] {
  outline: 2px solid var(--accent);
  outline-offset: 3px;
}
.linkRow {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 13px 0;
  border-bottom: 1px solid var(--line);
}
.linkRow svg:last-child {
  margin-left: auto;
}
.linkEditor {
  margin: 6px 0;
}
.linkEditor .inline {
  padding: 6px 0;
}
.iconPreview {
  display: flex;
  gap: 14px;
  align-items: center;
  margin: 10px 0;
}
.iconPreview > img,
.iconPreview > span {
  width: 38px;
  height: 38px;
  border-radius: 7px;
  object-fit: contain;
  background: var(--soft);
}
.iconPreview > span {
  display: grid;
  place-items: center;
}
.upload {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
}
.upload input {
  display: none;
}
.dayDetail {
  display: grid;
  gap: 10px;
}
.dayDetail .bar {
  min-height: 32px;
}
.banner {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  background: var(--panel);
  border-radius: 9px;
  padding: 8px 13px;
  flex-shrink: 0;
}
.banner > span {
  flex: 1;
}
.banner button {
  color: var(--accent);
}
.login {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: 24px;
  background:
    radial-gradient(ellipse at 20% 0, var(--blue-glow), transparent 70%),
    radial-gradient(ellipse at 100% 30%, var(--purple-glow), transparent 70%),
    var(--bg);
}
.loginCard {
  width: 360px;
  max-width: 100%;
  padding: 36px;
}
.loginCard > .brandIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
}
.loginCard h1 {
  margin: 18px 0 8px;
  font-weight: 600;
}
.loginCard > p {
  color: var(--muted);
  font-size: 13px;
  margin-bottom: 24px;
}
.loginCard .primary {
  width: 100%;
  margin-top: 16px;
}
.loading {
  display: grid;
  place-items: center;
  height: 100dvh;
  color: var(--muted);
}
.adminUser {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--line);
  padding: 12px 0;
}
.adminUser > span {
  flex: 1;
  min-width: 0;
}
.adminUser small {
  display: block;
  margin-top: 5px;
}
.adminUser button {
  font-size: 12px;
}
.jsonPreview {
  max-height: 220px;
  overflow: auto;
  background: var(--soft);
  border-radius: 8px;
  padding: 12px;
  font-size: 11px;
}
.statusList {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 12px;
  font-size: 13px;
}
.statusList dt {
  color: var(--muted);
}
.statusList dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.statusRow {
  padding: 13px 0;
  border-bottom: 1px solid var(--line);
  font-size: 12px;
}
.statusRow > span {
  margin-left: 15px;
}
.statusRow > small {
  display: block;
  margin: 6px 0;
}
.empty {
  padding: 25px;
  color: var(--muted);
  font-size: 13px;
}
.agenda {
  padding: 0 20px 20px;
  overflow: auto;
}
.agenda > section {
  padding: 14px 0;
  border-top: 1px solid var(--line);
}
.agenda h3 {
  margin: 0 0 10px;
}
.agenda .bar {
  min-height: 37px;
  margin: 7px 0;
}
.agenda .eventBar {
  min-height: 28px;
}
@media (max-width: 1100px) {
  .app {
    padding: 14px;
    gap: 13px;
  }
  .mast {
    gap: 18px;
    padding: 0 18px;
  }
  .panelHead {
    padding: 0 17px;
  }
  .panelHead .inline {
    gap: 2px;
  }
  .groups {
    gap: 9px;
  }
  .account {
    gap: 5px;
  }
  .saveState {
    display: none;
  }
  .filters {
    gap: 12px;
    padding: 0 17px;
  }
  .taskBody > span {
    font-size: 12px;
  }
}
@media (max-width: 800px) {
  .app {
    height: auto;
    min-height: 100dvh;
    padding: 10px;
    gap: 12px;
  }
  .mast {
    height: 56px;
    padding: 0 14px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .brand {
    font-size: 15px;
    gap: 7px;
  }
  .brandIcon {
    width: 27px;
    height: 27px;
  }
  .groups {
    order: 3;
    width: 100%;
    overflow: auto;
    gap: 16px;
    padding-bottom: 6px;
  }
  .mast {
    height: auto;
    min-height: 60px;
    padding-top: 12px;
  }
  .account {
    gap: 6px;
  }
  .avatar {
    display: none;
  }
  .navigation {
    border-radius: 15px;
  }
  .sites {
    gap: 0;
    padding: 6px 14px 12px;
  }
  .site .dragBody > a {
    font-size: 13px;
  }
  .site .grip,
  .navGroup .grip {
    display: none;
  }
  .addSite span {
    display: none;
  }
  .mobileTabs {
    display: flex;
    gap: 8px;
    justify-content: space-around;
  }
  .mobileTabs > button {
    flex: 1;
    color: var(--muted);
    padding: 10px;
  }
  .mobileTabs > button.active {
    color: var(--accent);
    background: var(--panel);
    box-shadow: var(--shadow);
  }
  .main {
    display: block;
    min-height: 0;
  }
  .split {
    display: none;
  }
  .app:not([data-mobile-page="calendar"]) .calendar {
    display: none;
  }
  .app:not([data-mobile-page="tasks"]) .tasks {
    display: none;
  }
  .app[data-mobile-page="navigation"] .sites {
    flex-wrap: wrap;
    white-space: normal;
    min-height: 180px;
    align-content: flex-start;
  }
  .calendar,
  .tasks {
    border-radius: 15px;
  }
  .panelHead {
    padding: 0 18px;
  }
  .taskScroll {
    overflow: visible;
  }
  .taskGroup {
    overflow: visible;
  }
  .cardShell {
    min-height: 0;
  }
  .cardHeader {
    padding: 14px 12px 2px;
  }
  .cardBody {
    overflow: visible;
    padding: 0 12px 12px;
  }
  .parentRow .grip,
  .columnEnd {
    display: none;
  }
  .taskBody > span {
    font-size: 14px;
  }
  .taskRow {
    min-height: 52px;
    padding-left: 8px;
  }
  .inlineTitle {
    font-size: 14px;
  }
  .inlineTitle[data-editing="true"] {
    font-size: 16px;
  }
  .taskRow .check {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
  }
  .taskRow .link {
    min-width: 36px;
    min-height: 36px;
  }
  .taskRow .grip {
    display: none;
  }
  .filters {
    height: 35px;
    gap: 21px;
  }
  .filters button {
    font-size: 13px;
  }
  .overlay {
    padding: 20px 10px;
  }
  .modal {
    max-height: calc(100dvh - 40px);
    padding: 20px;
    border-radius: 14px;
  }
  .modal input,
  .modal textarea,
  .modal select {
    font-size: 16px;
  }
  .modal .two {
    gap: 10px;
  }
  .adminUser {
    flex-wrap: wrap;
  }
  .adminUser > span {
    flex-basis: 100%;
  }
  .calendar .panelHead button[aria-label="上一周"],
  .calendar .panelHead button[aria-label="下一周"] {
    display: none;
  }
  .bar .resizeHandle,
  .bar .grip {
    display: none;
  }
  .loginCard {
    padding: 28px;
  }
}
